import { atom } from "jotai";

import { currentDurationOptionsAtom } from "../../stores";

export const durationBasedBookingValidGroupSizesSelectorAtom = atom<number[]>(
  (get) => {
    const validDurationOptions = get(currentDurationOptionsAtom);
    if (!validDurationOptions) {
      return [];
    }

    const allPlayerCounts = validDurationOptions.flatMap((option) =>
      option.endSlotOptions.flatMap((option) => option.allowedPlayerCounts)
    );

    return [...new Set(allPlayerCounts)].sort((a, b) => a - b);
  }
);
